import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmployeeSearchComponent } from './employee-search.component';
import { LinqFormsModule } from '../../forms/forms.module';
import { SharedModule } from '../../shared.module';

@NgModule({
    exports: [EmployeeSearchComponent],
    imports: [CommonModule, SharedModule, LinqFormsModule, EmployeeSearchComponent],
})
export class EmployeeSearchModule {}
